import { combineReducers } from 'redux';

import conversations from './conversations';
import currentUser from './currentUser';
import workspace from './workspace';
import cardStatistics from './cardStatistics';
import billingDetails from './billingDetails';
import products from './products';
import subproducts from './subproducts';
import botEditor from './botEditor';
import collections from './collections';
import ui from './ui';
import socket from './socket';
import websites from './websites';
import templates from './templates';
import feedback from './feedback';
import invites from './invites';
import checkout from './checkout';
import audience from './audience';

const rootReducer = combineReducers({
    conversations,
    currentUser,
    workspace,
    cardStatistics,
    billingDetails,
    products,
    subproducts,
    collections,
    invites,
    websites,
    templates,
    feedback,
    botEditor,
    ui,
    socket,
    checkout,
    audience,
});

export default rootReducer;
